module.exports = __webpack_public_path__ + "img/products2.4da29207.svg";